<template>
  <div
    :class="{ 'absolute bottom-0': !noAbsolute }"
    class="h-12 w-full bg-dark-gray"
  >
    <div class="container-max mx-auto h-full px-4 md:px-10">
      <div
        id="footer"
        class="flex h-full w-full items-center justify-between"
      >
        <div class="flex items-center gap-5">
          <a
            href="mailto:service@highway.com"
            class="text-2xs text-white hover:opacity-90"
          >
            service@highway.com
          </a>
          <a
            href="tel:906-HIGHWAY"
            class="text-2xs text-white hover:opacity-90"
          >
            906-HIGHWAY
          </a>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-2xs text-white">
            © {{ currentYear }} Highway App, Inc. All Rights Reserved.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterMain',
  components: {},
  props: {
    noAbsolute: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      SUPPORT_EMAIL: process.env.SUPPORT_EMAIL ?? '',
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    siteDomain() {
      if (process.env.SITE_DOMAIN === undefined) {
        return '';
      }
      return process.env.SITE_DOMAIN;
    },
  },
};
</script>
